var map = {
	"./chevron-left.svg": 647,
	"./chevron-right.svg": 648,
	"./facebook.svg": 649,
	"./instagram.svg": 650,
	"./loading.svg": 651,
	"./mastercard.svg": 652,
	"./menu.svg": 653,
	"./spinner.svg": 654,
	"./strava.svg": 655,
	"./trash.svg": 656,
	"./upload.svg": 657,
	"./visa.svg": 658,
	"./xlsx-file.svg": 659,
	"./youtube.svg": 660
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1259;



//////////////////
// WEBPACK FOOTER
// ./src/images/icons ^\.\/.*\.svg$
// module id = 1259
// module chunks = 0